import { useState, useEffect } from "react";
import PaginationComponent from "../../../components/PaginationComponent";
import useTopicHistory from "../../../utils/CustomHooks/useTopicHistory";
import QuestionTableItem from "../components/QuestionTableItem";

export default function TopicHistoryTable({ id = "" }) {
  const { topicHistory, loading, getTopicHistory } = useTopicHistory("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(topicHistory.length / pageSize);

  useEffect(() => {
    if (id) getTopicHistory(id);
  }, [id]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  return (
    <>
      <table className="table table-borderless ">
        <thead>
          <tr className=" ">
            <td className="">Action</td>
            <td className="">Time </td>
            <td className="">By</td>
          </tr>
        </thead>
        <tbody>
          {topicHistory.length > 0 ? (
            topicHistory
              .slice()
              .sort(
                (a, b) =>
                  new Date(b.updated_at ? b.updated_at : b.created_at) -
                  new Date(a.updated_at ? a.updated_at : a.created_at)
              )
              .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
              .map((x, i) => <QuestionTableItem data={x} key={i} />)
          ) : (
            <tr>
              <td className="text-center font-weight-bold" colSpan="7">
                {loading ? "loading..." : "No Hisory Found..."}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {topicHistory.length > 0 && (
        <PaginationComponent
          handleClick={handleClick}
          currentPage={currentPage}
          pageCount={pageCount}
        />
      )}
    </>
  );
}
